import { VAlert } from 'vuetify/lib/components/VAlert';
import { VFadeTransition } from 'vuetify/lib/components/transitions';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toast-position-fixed toast-width d-flex flex-column"},[_c(VFadeTransition,{attrs:{"mode":"out-in","group":""}},_vm._l((_vm.toasts),function(toast,index){return _c(VAlert,{key:(index + "-" + (toast.uuid)),attrs:{"value":toast.visible,"type":toast.type,"dismissible":true}},[_c('span',[_vm._v(_vm._s(toast.msg))])])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }